var map = {
	"./webspecial_food_spargel_cn.mp4": 465,
	"./webspecial_food_spargel_de.mp4": 4487,
	"./webspecial_food_spargel_en.mp4": 5771,
	"./webspecial_food_spargel_ja.mp4": 5149,
	"./webspecial_food_spargel_tr.mp4": 5236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4505;